export const validateBookServiceForm = (formData) => {
  const errors = {};

  // Name validation
  if (!formData.userName.trim()) {
    errors.userName = "Name is required";
  }

  if (!formData.contactNo || formData.contactNo.trim().length < 1) {
    errors.contactNo = "Contact number is required.";
  } else if (!/^\d{1,15}$/.test(formData.contactNo)) {
    errors.contactNo =
      "Contact number must be a valid numeric value with up to 15 digits.";
  }

  // Email validation
  if (!formData.emailAddress.trim()) {
    errors.emailAddress = "Email is required";
  } else if (
    !/^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
      formData.emailAddress
    )
  ) {
    errors.emailAddress = "Enter a valid email address";
  }

  // Country validation
  if (!formData.flatNumber.trim()) {
    errors.flatNumber = "House/Flat  Number is required";
  }
  // Subject validation
  if (!formData.streetCross.trim()) {
    errors.streetCross = "Street / Cross  is required";
  }
  if (!formData.locality.trim()) {
    errors.locality = "Locality/ Area  is required";
  }
  if (!formData.pincode.trim()) {
    errors.pincode = "Pin Code Number is required";
  }

  return errors; // Return all errors
};
